/** @format */

import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TDoctorInfo } from "../apis/types";
import { RootState } from ".";

const initialState = {
  doctorInfo: {} as TDoctorInfo,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setDoctorInfo(state, action: PayloadAction<TDoctorInfo>) {
      state.doctorInfo = action.payload;
    },
    updateDoctorProfilePicture(state, action: PayloadAction<string>) {
      if (state.doctorInfo) {
        state.doctorInfo.profilePicture = action.payload;
      }
    },
    logoutDoctor(state) {
      state.doctorInfo = {} as TDoctorInfo;
    },
  },
});

export const { setDoctorInfo, updateDoctorProfilePicture, logoutDoctor } =
  authSlice.actions;

export default authSlice.reducer;

// Optional selector
export const selectCurrentDoctorInfo = (state: RootState) =>
  state.auth.doctorInfo;
